import { render, staticRenderFns } from "./ViewOnlyJsonViewer.vue?vue&type=template&id=6ca74e1e&scoped=true&"
import script from "./ViewOnlyJsonViewer.vue?vue&type=script&lang=js&"
export * from "./ViewOnlyJsonViewer.vue?vue&type=script&lang=js&"
import style0 from "./ViewOnlyJsonViewer.vue?vue&type=style&index=0&id=6ca74e1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca74e1e",
  null
  
)

export default component.exports